import { useAppStore } from '@/stores/appStore'

/**
 * The startup the signed-in user is currently working in.
 *
 * Legacy service methods were written before the API became multi-tenant and
 * take no startupId. Rather than thread one through every call site, they read
 * it from here and build a scoped URL.
 *
 * Throwing beats guessing: the backend used to fall back to the caller's uid
 * when a request arrived without startup context, which silently filed uploads
 * under a startupId that was really a user id — processed, indexed, and
 * invisible to every screen.
 */
export function activeStartupId(): string {
  const startupId = useAppStore.getState().startup?.id
  if (!startupId) {
    throw new Error('No active startup yet — wait for the app shell to load one.')
  }
  return startupId
}

/** Build a startup-scoped path, e.g. scopedTo('/documents') for the active startup. */
export function scopedTo(path: string): string {
  return `/v1/startups/${encodeURIComponent(activeStartupId())}${path}`
}
